(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMiuseaBeforeAfterSlider() {
    if (window.innerWidth > 750) return;

    const candidates = Array.from(document.querySelectorAll(
      '.before-after, before-after, [class*="before-after"], [class*="before_after"]'
    ));

    if (!candidates.length) return;

    const possibleCards = [];

    candidates.forEach((el) => {
      let node = el;
      for (let i = 0; i < 6 && node && node.parentElement; i++) {
        const parent = node.parentElement;
        const directChildren = Array.from(parent.children);
        const childrenWithBeforeAfter = directChildren.filter((child) =>
          child.querySelector('.before-after, before-after, [class*="before-after"], [class*="before_after"]')
        );

        if (childrenWithBeforeAfter.length >= 2) {
          possibleCards.push({ track: parent, cards: childrenWithBeforeAfter });
          break;
        }
        node = parent;
      }
    });

    if (!possibleCards.length) return;

    /* On prend le groupe qui contient le plus de cartes avant/après */
    possibleCards.sort((a, b) => b.cards.length - a.cards.length);
    const { track, cards } = possibleCards[0];

    track.classList.add('miusea-before-after-mobile-slider');
    cards.forEach((card) => card.classList.add('miusea-before-after-mobile-slide'));
  }

  function run() {
    initMiuseaBeforeAfterSlider();
    setTimeout(initMiuseaBeforeAfterSlider, 300);
    setTimeout(initMiuseaBeforeAfterSlider, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();

  } catch(e) { console.error(e); }
})();
})();
